import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getDepositRequestDetail } from '../depositRequestsEndpoints'
import { depositRequestKeys } from '../depositRequestsQueryKeys'

export function useDepositRequestDetailQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => depositRequestKeys.detail(toValue(id)),
    queryFn: () => getDepositRequestDetail(toValue(id)),
    enabled: () => !!toValue(id),
  })
}
